import React, { useState, useEffect } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { getChartOfAccounts } from "api/accountsAPI";
import { Button } from "@progress/kendo-react-buttons";
import styles from "../Settings/Settings.module.scss";
import AddEditChartAccounts from "./AddEditChartAccounts";
import {
  ActiveCell,
  SignatureCell,
  EditCommandCell,
} from "../Settings/GridComponents";
import { Dialog } from "@progress/kendo-react-dialogs";
import { GridLoader } from "components/GridLoader";

const initialDataState = {
  sort: [{ field: "name", dir: "asc" }],
  take: 10,
  skip: 0,
};

const ChartOfAccounts = () => {
  const [dataState, setDataState] = useState(initialDataState);
  const [accounts, setAccounts] = useState([]);
  const [editData, setEditData] = useState(null);
  const [showAddEdit, setShowAddEdit] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDataStateChange = (e) => {
    setDataState(e.dataState);
  };

  useEffect(() => {
    fetchAccounts();
  }, []);
  const fetchAccounts = async () => {
    setLoading(true);
    try {
      const response = await getChartOfAccounts();
      const accountsWithFirstLetter = (response?.data?.data || []).map(
        (account) => ({
          ...account,
          symbol: account.name ? account.name.charAt(0) : "",
        })
      );
      setAccounts(accountsWithFirstLetter);
    } catch (error) {
      console.error("Error fetching accounts:", error);
    } finally {
      setLoading(false);
    }
  };

  const TypeCell = (props) => {
    const formatType = (type) => {
      if (!type) return "";
      return type.replace(/([A-Z])/g, " $1").trim();
    };
    return (
      <td>
        <span>{formatType(props.dataItem.type)}</span>
      </td>
    );
  };

  const handleAddNew = (dataItem) => {
    setShowAddEdit(true);
    setEditData(dataItem || null);
    setShowDialog(true);
  };
  const handleCloseDialog = () => {
    setShowDialog(false);
    setEditData(null);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell
      {...props}
      enterEdit={() => handleAddNew(props.dataItem)}
    />
  );

  return (
    <div className="d-flex flex-column h-100 w-100 overflow-hidden">
      <div className="d-flex justify-content-end mb-3 flex-shrink-0">
        <Button
          className={`common-btn p-3 py-4`}
          onClick={() => handleAddNew("")}
        >
          Add Chart<br />
          of Accounts
        </Button>
      </div>

      <div className="flex-grow-1 settings-grid settings-grid-wrapper mb-2" style={{ minHeight: 0, maxWidth: "1000px" }}>
        <Grid
          data={process(accounts, dataState)}
          {...dataState}
          onDataStateChange={handleDataStateChange}
          style={{ height: "100%" }}
          showLoader={loading}
          loader={
            <div style={{ height: "50px" }}>
              <GridLoader />
            </div>
          }
        >
          <GridNoRecords>
            {loading ? (
              <span></span>
            ) : (
              accounts && accounts?.length === 0 && "No records available"
            )}
          </GridNoRecords>
          <Column
            field="symbol"
            title=" "
            cell={SignatureCell}
            width="40px"
          />
          <Column field="name" title="Name" width="120px" />
          <Column field="type" title="Type" cell={TypeCell} width="120px" />
          <Column
            field="active"
            title="Active"
            width="30px"
            cell={ActiveCell}
          />
          <Column title=" " cell={MyEditCommandCell} width="30px" />
        </Grid>
      </div>

      {showDialog && (
        <Dialog
          title={editData ? "Edit Chart of Accounts" : "Add Chart of Accounts"}
          onClose={handleCloseDialog}
          className="dialog-xxl"
        >
          <AddEditChartAccounts
            onClose={handleCloseDialog}
            editData={editData}
            onSave={() => {
              handleCloseDialog();
              fetchAccounts();
            }}
          />
        </Dialog>
      )}
    </div>
  );
};

export default ChartOfAccounts;
